import React from 'react';
import '@redq/reuse-modal/es/index.css';
import FoodDelivery from "./fooddelivery";


export default FoodDelivery;
